import { ArrowSquareOut, CheckCircle, DeviceMobile, QrCode } from "@phosphor-icons/react";

const DOWNLOAD_URL = "https://aka.ms/mobileauthenticator";
const HELP_URL = "https://support.microsoft.com/pt-br/authenticator/download-microsoft-authenticator";

export default function AuthenticatorSetupGuide({ setupQrDataUrl, manualKey }) {
  return (
    <div className="space-y-4">
      <div className="border border-border bg-muted/20 p-4">
        <div className="flex items-start gap-3">
          <DeviceMobile size={24} weight="duotone" className="text-primary shrink-0 mt-0.5" />
          <div>
            <h3 className="font-display text-xl font-black tracking-tight">Como configurar</h3>
            <p className="text-sm text-muted-foreground mt-1">
              São dois códigos QR diferentes: o primeiro instala o aplicativo; o segundo adiciona sua conta SAKI/Xm.
            </p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <section className="border border-border bg-card p-4 flex flex-col">
          <div className="flex items-center gap-2 mb-3">
            <span className="w-7 h-7 flex items-center justify-center bg-primary text-primary-foreground font-mono-data font-bold">1</span>
            <div>
              <h4 className="font-semibold">Baixe o Microsoft Authenticator</h4>
              <p className="text-xs text-muted-foreground">Leia este QR com a câmera comum do celular.</p>
            </div>
          </div>

          <div className="flex justify-center bg-white border border-border p-3">
            <img
              src="/microsoft-authenticator-download.png"
              alt="QR code para baixar o Microsoft Authenticator"
              className="w-40 h-40"
            />
          </div>

          <a
            href={DOWNLOAD_URL}
            target="_blank"
            rel="noreferrer noopener"
            className="mt-3 inline-flex items-center justify-center min-h-10 px-4 border border-border bg-background hover:bg-muted text-sm font-semibold"
          >
            Abrir página oficial de download
            <ArrowSquareOut size={15} className="ml-2" />
          </a>
          <a
            href={HELP_URL}
            target="_blank"
            rel="noreferrer noopener"
            className="text-xs text-primary hover:underline text-center mt-2"
          >
            Ver instruções oficiais da Microsoft
          </a>
        </section>

        <section className="border border-primary bg-card p-4 flex flex-col">
          <div className="flex items-center gap-2 mb-3">
            <span className="w-7 h-7 flex items-center justify-center bg-primary text-primary-foreground font-mono-data font-bold">2</span>
            <div>
              <h4 className="font-semibold">Adicione sua conta SAKI/Xm</h4>
              <p className="text-xs text-muted-foreground">Leia este QR dentro do Microsoft Authenticator.</p>
            </div>
          </div>

          <div className="flex justify-center bg-white border border-border p-3">
            <img
              src={setupQrDataUrl}
              alt="QR code para configurar a conta SAKI/Xm no aplicativo autenticador"
              className="w-40 h-40"
            />
          </div>

          <div className="mt-3 text-sm space-y-1.5">
            <div className="flex gap-2"><QrCode size={17} className="text-primary shrink-0 mt-0.5" /><span>Abra o aplicativo e toque em <strong>+</strong>.</span></div>
            <div className="pl-6">Escolha <strong>Outra conta</strong>.</div>
            <div className="pl-6">Toque em <strong>Digitalizar código QR</strong>.</div>
          </div>
        </section>
      </div>

      <section className="border border-border bg-card p-4">
        <div className="flex items-start gap-3">
          <span className="w-7 h-7 flex items-center justify-center bg-primary text-primary-foreground font-mono-data font-bold shrink-0">3</span>
          <div className="min-w-0">
            <h4 className="font-semibold">Digite o código de 6 dígitos</h4>
            <p className="text-sm text-muted-foreground mt-1">
              O aplicativo criará a conta <strong>SAKI/Xm</strong> e exibirá um código que muda periodicamente. Em contas configuradas anteriormente, o nome <strong>SAKI X TESTS</strong> pode continuar aparecendo. Digite esse código abaixo.
            </p>
            <div className="flex items-center gap-2 mt-2 text-xs text-muted-foreground">
              <CheckCircle size={15} className="text-primary" />
              Não use a câmera comum para o segundo QR.
            </div>
          </div>
        </div>
      </section>

      {manualKey && (
        <details className="border border-border bg-card p-3">
          <summary className="cursor-pointer text-sm font-semibold">Não consigo ler o QR — usar chave manual</summary>
          <p className="text-xs text-muted-foreground mt-2">
            No Authenticator, escolha inserir uma chave de configuração e copie o código abaixo.
          </p>
          <code className="block font-mono-data text-sm break-all text-center mt-2 p-2 bg-muted/40 select-all">{manualKey}</code>
        </details>
      )}
    </div>
  );
}
